module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ge-cta-arrow', _vm.theme],
    style: (_vm.styleObject)
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-3df0e570"}!F:/Solutions/6713ge/master/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ge-cta-arrow/ge-cta-arrow.vue
// module id = 349
// module chunks = 1